<template>
<v-app>
     <transition name="fade" mode="out-in" appear>
          <Login v-if="!isLogin" />
     </transition>

     <transition name="fade" mode="out-in" appear>
          <v-app v-if="isLogin">
               <AppBar />
               <v-content class="content">
                    <Stage /> 
                    <v-container fluid>
                         <transition name="slide-fade" mode="out-in">
                              <router-view></router-view>
                         </transition>
                    </v-container>
               </v-content>
          </v-app>

     </transition>

</v-app>
</template>

<script>
export default {
     name: 'App',

     components: {
          Login: () => import('@/views/dashboard/login'),
          AppBar: () => import('@/views/dashboard/components/AppBar'),
          Stage: () => import('@/views/dashboard/stage')
     },

     data: () => ({
          
     }),
     computed: {
          isLogin() {
               return this.$store.state.access_token
          }
     },
     
     methods: { 
          changLAng() {
               let lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'fr'
               this.$i18n.locale = lang;
               setTimeout(() => {
                    var f = document.querySelectorAll("*")

                    for (var i = 0; i < f.length; i++) {
                         if (lang == "ar") {
                              f[i].style.setProperty("font-family", "Droid", "important")
                         } else {
                              f[i].style.setProperty("font-family", "DroidSans", "important")
                         }
                    }

               }, 0);
               if (lang == "ar") {
                    this.$vuetify.rtl = true;
               } else {
                    this.$vuetify.rtl = false;
               }
          }
     },
     created() {
          Fire.$on('isLogin', (e) => {
               this.isLogin = true
          })
          Fire.$on('ChangeLangs', e => {
               this.changLAng()
          })
          document.documentElement.style.overflow = 'hidden'
          this.changLAng()
     },
};
</script>

<style scoped>
.content {
     background: url('./assets/admin/bg.jpg');
     background-size: 100% 100%;
     background-attachment: fixed;
     background-repeat: no-repeat;
}
</style>
<style>
 /* ----------------------------------------------
 * Generated by Animista on 2019-7-23 19:14:53
 * http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
 /* ----------------------------------------------
 * Generated by Animista on 2019-7-23 19:15:40
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

 /*
 * ----------------------------------------
 * animation swing-out-top-bck
 * ----------------------------------------
 */
 @-webkit-keyframes swing-out-top-bck {
      0% {
           -webkit-transform: rotateX(0deg);
           transform: rotateX(0deg);
           -webkit-transform-origin: top;
           transform-origin: top;
           opacity: 1;
      }

      100% {
           -webkit-transform: rotateX(-100deg);
           transform: rotateX(-100deg);
           -webkit-transform-origin: top;
           transform-origin: top;
           opacity: 0;
      }
 }

 @keyframes swing-out-top-bck {
      0% {
           -webkit-transform: rotateX(0deg);
           transform: rotateX(0deg);
           -webkit-transform-origin: top;
           transform-origin: top;
           opacity: 1;
      }

      100% {
           -webkit-transform: rotateX(-100deg);
           transform: rotateX(-100deg);
           -webkit-transform-origin: top;
           transform-origin: top;
           opacity: 0;
      }
 }

 /**
 * ----------------------------------------
 * animation swing-in-top-fwd
 * ----------------------------------------
 */
 @-webkit-keyframes swing-in-top-fwd {
      0% {
           -webkit-transform: rotateX(-100deg);
           transform: rotateX(-100deg);
           -webkit-transform-origin: top;
           transform-origin: top;
           opacity: 0;
      }

      100% {
           -webkit-transform: rotateX(0deg);
           transform: rotateX(0deg);
           -webkit-transform-origin: top;
           transform-origin: top;
           opacity: 1;
      }
 }

 @keyframes swing-in-top-fwd {
      0% {
           -webkit-transform: rotateX(-100deg);
           transform: rotateX(-100deg);
           -webkit-transform-origin: top;
           transform-origin: top;
           opacity: 0;
      }

      100% {
           -webkit-transform: rotateX(0deg);
           transform: rotateX(0deg);
           -webkit-transform-origin: top;
           transform-origin: top;
           opacity: 1;
      }
 }

 .drag {

      background: #fff;
      -webkit-transition: background-color 200ms linear;
      -ms-transition: background-color 200ms linear;
      transition: background-color 200ms linear;
      box-shadow: 0px 1px 8px 0px;
 }

 .contents {
      position: relative !important;
      height: 100% !important;
 }

 .my-dragging-class {
      background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2Q4ZWNmYiIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==');
      background-image: linear-gradient(#d8ecfb, #ffffff);

 }

 .v-parallax {
      position: absolute;
      width: 90%;
      height: 100% !important;
      top: 32px;
      right: 0;
      overflow: hidden;
      z-index: 0;
 }

 .handles {
      position: absolute;
      width: 5px;
      height: 5px;
      -webkit-transition: all 200ms linear;
      -ms-transition: all 200ms linear;
      transition: all 200ms linear;
 }

 .handles-tl {
      top: 0px;
      z-index: 1000;
      left: 0;
      cursor: nw-resize;
      background-color: transparent;
 }

 .handles-tm {
      top: 0;
      z-index: 999;
      left: 0;
      width: 100%;
      cursor: n-resize;
      background-color: transparent;
 }

 .handles-tr {
      top: 0;
      z-index: 1000;
      right: 0;
      height: 5px;
      cursor: ne-resize;
      background-color: transparent;
 }

 .handles-ml {
      top: 0px;
      z-index: 999;
      left: 0px;
      height: calc(100% + 50px);
      cursor: w-resize;
      background-color: transparent;
 }

 .handles-mr {
      top: 0px;
      z-index: 999;
      height: calc(100% + 50px);
      right: 0;
      cursor: e-resize;
      background-color: transparent;
 }

 .handles-bl {
      bottom: -50px;
      z-index: 1000;
      left: 0;
      cursor: sw-resize;
      background-color: transparent;
 }

 .handles-bm {
      left: 0;
      z-index: 999;
      bottom: -50px;
      width: 100%;
      cursor: s-resize;
      background-color: transparent;
 }

 .handles-br {
      bottom: -50px;
      z-index: 1000;
      right: 0px;
      height: 5px;
      cursor: se-resize;
      background-color: transparent;

 }

 .drag-handle {
      /* margin-top:15px !important; */
      border-top: 3px solid #33B4BC;
      background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2Q4ZWNmYiIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==');
      background-image: linear-gradient(#d8ecfb, #ffffff);
      cursor: move
 }

 .app-flat-leave-active {
      -webkit-animation: slide-out-elliptic-top-bck 0.2s ease-in both;
      animation: slide-out-elliptic-top-bck 0.2s ease-in both;
 }

 .app-flat-enter-active {
      -webkit-animation: slide-in-elliptic-top-fwd 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
      animation: slide-in-elliptic-top-fwd 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
 }

 /* ----------------------------------------------
 * Generated by Animista on 2019-12-18 13:9:49
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

 /**
 * ----------------------------------------
 * animation slide-out-elliptic-top-bck
 * ----------------------------------------
 */
 @-webkit-keyframes slide-out-elliptic-top-bck {
      0% {
           -webkit-transform: translateY(0) rotateX(0) scale(1);
           transform: translateY(0) rotateX(0) scale(1);
           -webkit-transform-origin: 50% 1400px;
           transform-origin: 50% 1400px;
           opacity: 1;
      }

      100% {
           -webkit-transform: translateY(-600px) rotateX(30deg) scale(0);
           transform: translateY(-600px) rotateX(30deg) scale(0);
           -webkit-transform-origin: 50% 100%;
           transform-origin: -20% 100%;
           opacity: 1;
      }
 }

 @keyframes slide-out-elliptic-top-bck {
      0% {
           -webkit-transform: translateY(0) rotateX(0) scale(1);
           transform: translateY(0) rotateX(0) scale(1);
           -webkit-transform-origin: 50% 1400px;
           transform-origin: 50% 1400px;
           opacity: 1;
      }

      100% {
           -webkit-transform: translateY(-600px) rotateX(30deg) scale(0);
           transform: translateY(-600px) rotateX(30deg) scale(0);
           -webkit-transform-origin: 50% 100%;
           transform-origin: -20% 100%;
           opacity: 1;
      }
 }

 /* ----------------------------------------------
 * Generated by Animista on 2019-12-18 13:11:3
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

 /**
 * ----------------------------------------
 * animation slide-in-elliptic-top-fwd
 * ----------------------------------------
 */
 @-webkit-keyframes slide-in-elliptic-top-fwd {
      0% {
           -webkit-transform: translateY(-600px) rotateX(-30deg) scale(0);
           transform: translateY(-600px) rotateX(-30deg) scale(0);
           -webkit-transform-origin: 50% 100%;
           transform-origin: 50% 100%;
           opacity: 0;
      }

      100% {
           -webkit-transform: translateY(0) rotateX(0) scale(1);
           transform: translateY(0) rotateX(0) scale(1);
           -webkit-transform-origin: 50% 1400px;
           transform-origin: 50% 1400px;
           opacity: 1;
      }
 }

 @keyframes slide-in-elliptic-top-fwd {
      0% {
           -webkit-transform: translateY(-600px) rotateX(-30deg) scale(0);
           transform: translateY(-600px) rotateX(-30deg) scale(0);
           -webkit-transform-origin: 50% 100%;
           transform-origin: 50% 100%;
           opacity: 0;
      }

      100% {
           -webkit-transform: translateY(0) rotateX(0) scale(1);
           transform: translateY(0) rotateX(0) scale(1);
           -webkit-transform-origin: 50% 1400px;
           transform-origin: 50% 1400px;
           opacity: 1;
      }
 }

 #appinspire {
      height: calc(100% - 30px) !important;
 }

 #appinspire .v-navigation-drawer {
      height: 100% !important;
      background-image: none !important;
 }

 #appinspire .v-application--wrap {
      display: contents !important;
 }
</style>
